import { gql } from '@apollo/client';
import {
  USER_BASIC_FIELDS,
  ID_NAME_FIELDS,
  COUNTRY_FIELDS,
  PROPERTY_MAIN_FIELDS,
} from 'graphql/common/fragments';

export const PRICE_QUOTE_INFO_FRAGMENT = gql`
  fragment priceQuoteInfo on PropertyPriceQuote {
    id
    escalationFormatted
    createdAt
    updatedAt
    date
    askingRentPsf
    leaseTypeId
    rentType
    tiAllowance
    freeRentMonths
    term
    source
    pricing
    floors
    size
    sizeMt
    comment
    opExAndTaxes
    taxes
    operatingExpenses
    tenantCompany {
      ${ID_NAME_FIELDS}
    }
    property {
      ${PROPERTY_MAIN_FIELDS}
      propertyCountry {
        ${COUNTRY_FIELDS}
      }
      market {
        ${ID_NAME_FIELDS}
      }
      submarket {
        ${ID_NAME_FIELDS}
      }
      micromarket {
        ${ID_NAME_FIELDS}
      }
      propertyType {
        ${ID_NAME_FIELDS}
      }
      propertyClass {
        ${ID_NAME_FIELDS}
      }
    }
    createdUser {
      ${USER_BASIC_FIELDS}
    }
    updatedUser {
      ${USER_BASIC_FIELDS}
    }
  }
`;
